import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { api } from "../lib/api";
import { FreteLocalFields } from "./FreteLocalFields";

export const NovaVersaoDialog = ({ proposta, onClose, onCreated }) => {
  const [frete, setFrete] = useState("");
  const [local, setLocal] = useState("");
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    setFrete(proposta?.frete || "");
    setLocal(proposta?.local_operacao || "");
  }, [proposta]);

  const criar = async () => {
    if (!frete) return toast.error("Selecione o frete");
    setSalvando(true);
    try {
      const { data } = await api.post(`/proposta-nativa/${proposta.id}/nova-versao`, { frete, local_operacao: local || null });
      toast.success(`Versão v${data.versao} criada como rascunho`);
      onCreated?.();
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Falha ao criar versão");
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Dialog open={!!proposta} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="nova-versao-dialog">
        <DialogHeader>
          <DialogTitle>Nova versão da proposta {proposta?.numero}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground text-justify">
          A versão atual permanece no histórico. A nova versão é criada como rascunho e precisa ser enviada e assinada novamente
        </p>
        <FreteLocalFields frete={frete} local={local} onFrete={setFrete} onLocal={setLocal} prefix="nova-versao" />
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} data-testid="nova-versao-cancelar">Cancelar</Button>
          <Button onClick={criar} disabled={salvando} data-testid="nova-versao-confirmar">Criar versão</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
